 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import BOOK1OPSBACKEDBIRDSFRONT_1 from '@/components/Book1/OPS/Backed/birdsfront_1'
 import BOOK1OPSBACKEDPORTALIST_AD from '@/components/Book1/OPS/Backed/portalist_ad'
 import BOOK1OPS2PRAISE from '@/components/Book1/OPS/2-praise'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1OPS1COVER from '@/components/Book1/OPS/1-cover'
 import BOOK1OPS3TITLE_PAGE from '@/components/Book1/OPS/3-title_page'
 import BOOK1OPS4DEDICATION from '@/components/Book1/OPS/4-dedication'
 import BOOK1OPS5TOC from '@/components/Book1/OPS/5-TOC'
 import BOOK1OPS6CHAP1 from '@/components/Book1/OPS/6-chap1'
 import BOOK1OPS7PART from '@/components/Book1/OPS/7-part'
 import BOOK1OPS8CHAP2 from '@/components/Book1/OPS/8-chap2'
 import BOOK1OPS9CHAP3 from '@/components/Book1/OPS/9-chap3'
 import BOOK1OPS10CHAP4 from '@/components/Book1/OPS/10-chap4'
 import BOOK1OPS11CHAP5 from '@/components/Book1/OPS/11-chap5'
 import BOOK1OPS12CHAP6 from '@/components/Book1/OPS/12-chap6'
 import BOOK1OPS13CHAP7 from '@/components/Book1/OPS/13-chap7'
 import BOOK1OPS14CHAP8 from '@/components/Book1/OPS/14-chap8'
 import BOOK1OPS15CHAP9 from '@/components/Book1/OPS/15-chap9'
 import BOOK1OPS16CHAP10 from '@/components/Book1/OPS/16-chap10'
 import BOOK1OPS17CHAP11 from '@/components/Book1/OPS/17-chap11'
 import BOOK1OPS18CHAP12 from '@/components/Book1/OPS/18-chap12'
 import BOOK1OPS19CHAP13 from '@/components/Book1/OPS/19-chap13'
 import BOOK1OPS20CHAP14 from '@/components/Book1/OPS/20-chap14'
 import BOOK1OPS21CHAP15 from '@/components/Book1/OPS/21-chap15'
 import BOOK1OPS22CHAP16 from '@/components/Book1/OPS/22-chap16'
 import BOOK1OPS23CHAP17 from '@/components/Book1/OPS/23-chap17'
 import BOOK1OPS24CHAP18 from '@/components/Book1/OPS/24-chap18'
 import BOOK1OPS25CHAP19 from '@/components/Book1/OPS/25-chap19'
 import BOOK1OPS26CHAP20 from '@/components/Book1/OPS/26-chap20'
 import BOOK1OPS27CHAP21 from '@/components/Book1/OPS/27-chap21'
 import BOOK1OPS28CHAP22 from '@/components/Book1/OPS/28-chap22'
 import BOOK1OPS29CHAP23 from '@/components/Book1/OPS/29-chap23'
 import BOOK1OPS30CHAP24 from '@/components/Book1/OPS/30-chap24'
 import BOOK1OPS31CHAP25 from '@/components/Book1/OPS/31-chap25'
 import BOOK1OPS32CHAP26 from '@/components/Book1/OPS/32-chap26'
 import BOOK1OPS33CHAP27 from '@/components/Book1/OPS/33-chap27'
 import BOOK1OPS34CHAP28 from '@/components/Book1/OPS/34-chap28'
 import BOOK1OPS35CHAP29 from '@/components/Book1/OPS/35-chap29'
 import BOOK1OPS36CHAP30 from '@/components/Book1/OPS/36-chap30'
 import BOOK1OPS37PREVIEW from '@/components/Book1/OPS/37-preview'
 import BOOK1OPS38PREVIEW from '@/components/Book1/OPS/38-preview'
 import BOOK1OPS39CHAP31 from '@/components/Book1/OPS/39-chap31'
 import BOOK1OPS40CHAP32 from '@/components/Book1/OPS/40-chap32'
 import BOOK1OPS41CHAP33 from '@/components/Book1/OPS/41-chap33'
 import BOOK2OPS1COVER from '@/components/Book2/OPS/1-cover'
 import BOOK2OPS3TITLE_PAGE from '@/components/Book2/OPS/3-title_page'
 import BOOK2OPS4DEDICATION from '@/components/Book2/OPS/4-dedication'
 import BOOK2OPS5TOC from '@/components/Book2/OPS/5-TOC'
 import BOOK2OPS6EPIGRAPH from '@/components/Book2/OPS/6-epigraph'
 import BOOK2OPS7CHAP1 from '@/components/Book2/OPS/7-chap1'
 import BOOK2OPS8CHAP2 from '@/components/Book2/OPS/8-chap2'
 import BOOK2OPS9CHAP3 from '@/components/Book2/OPS/9-chap3'
 import BOOK2OPS10CHAP4 from '@/components/Book2/OPS/10-chap4'
 import BOOK2OPS11CHAP5 from '@/components/Book2/OPS/11-chap5'
 import BOOK2OPS12CHAP6 from '@/components/Book2/OPS/12-chap6'
 import BOOK2OPS13CHAP7 from '@/components/Book2/OPS/13-chap7'
 import BOOK2OPS14CHAP8 from '@/components/Book2/OPS/14-chap8'
 import BOOK2OPS15CHAP9 from '@/components/Book2/OPS/15-chap9'
 import BOOK2OPS16CHAP10 from '@/components/Book2/OPS/16-chap10'
 import BOOK2OPS17CHAP11 from '@/components/Book2/OPS/17-chap11'
 import BOOK2OPS18CHAP12 from '@/components/Book2/OPS/18-chap12'
 import BOOK2OPS19CHAP13 from '@/components/Book2/OPS/19-chap13'
 import BOOK2OPS20CHAP14 from '@/components/Book2/OPS/20-chap14'
 import BOOK2OPS21CHAP15 from '@/components/Book2/OPS/21-chap15'
 import BOOK3OPS1COVER from '@/components/Book3/OPS/1-cover'
 import BOOK3OPS3TITLE_PAGE from '@/components/Book3/OPS/3-title_page'
 import BOOK3OPS4DEDICATION from '@/components/Book3/OPS/4-dedication'
 import BOOK3OPS5NOTE from '@/components/Book3/OPS/5-note'
 import BOOK3OPS6TOC from '@/components/Book3/OPS/6-TOC'
 import BOOK3OPS7EPIGRAPH from '@/components/Book3/OPS/7-epigraph'
 import BOOK3OPS8CHAP1 from '@/components/Book3/OPS/8-chap1'
 import BOOK3OPS9CHAP2 from '@/components/Book3/OPS/9-chap2'
 import BOOK3OPS10CHAP3 from '@/components/Book3/OPS/10-chap3'
 import BOOK3OPS11CHAP4 from '@/components/Book3/OPS/11-chap4'
 import BOOK3OPS12CHAP5 from '@/components/Book3/OPS/12-chap5'
 import BOOK3OPS13CHAP6 from '@/components/Book3/OPS/13-chap6'
 import BOOK3OPS14CHAP7 from '@/components/Book3/OPS/14-chap7'
 import BOOK3OPS15CHAP8 from '@/components/Book3/OPS/15-chap8'
 import BOOK3OPS16CHAP9 from '@/components/Book3/OPS/16-chap9'
 import BOOK3OPS17CHAP10 from '@/components/Book3/OPS/17-chap10'
 import BOOK3OPS18CHAP11 from '@/components/Book3/OPS/18-chap11'
 import BOOK3OPS19CHAP12 from '@/components/Book3/OPS/19-chap12'
 import BOOK3OPS20CHAP13 from '@/components/Book3/OPS/20-chap13'
 import BOOK3OPS21CHAP14 from '@/components/Book3/OPS/21-chap14'
 import BOOK3OPS22CHAP15 from '@/components/Book3/OPS/22-chap15'
 import BOOK3OPS23CHAP16 from '@/components/Book3/OPS/23-chap16'
 import BOOK3OPS24CHAP17 from '@/components/Book3/OPS/24-chap17'
 import BOOK3OPS25CHAP18 from '@/components/Book3/OPS/25-chap18'
 import BOOK3OPS26CHAP19 from '@/components/Book3/OPS/26-chap19'
 import BOOK3OPS27PART from '@/components/Book3/OPS/27-part'
 import BOOK3OPS28PART from '@/components/Book3/OPS/28-part'
 import BOOK3OPS29CHAP20 from '@/components/Book3/OPS/29-chap20'
 import BOOK3OPS30CHAP21 from '@/components/Book3/OPS/30-chap21'
 import BOOK4OPS1COVER from '@/components/Book4/OPS/1-cover'
 import BOOK4OPS3TITLE_PAGE from '@/components/Book4/OPS/3-title_page'
 import BOOK4OPS4DEDICATION from '@/components/Book4/OPS/4-dedication'
 import BOOK4OPS5NOTE from '@/components/Book4/OPS/5-note'
 import BOOK4OPS6TOC from '@/components/Book4/OPS/6-TOC'
 import BOOK4OPS7CHAP1 from '@/components/Book4/OPS/7-chap1'
 import BOOK4OPS8CHAP2 from '@/components/Book4/OPS/8-chap2'
 import BOOK4OPS9CHAP3 from '@/components/Book4/OPS/9-chap3'
 import BOOK4OPS10CHAP4 from '@/components/Book4/OPS/10-chap4'
 import BOOK4OPS11CHAP5 from '@/components/Book4/OPS/11-chap5'
 import BOOK4OPS12CHAP6 from '@/components/Book4/OPS/12-chap6'
 import BOOK4OPS13CHAP7 from '@/components/Book4/OPS/13-chap7'
 import BOOK4OPS14CHAP8 from '@/components/Book4/OPS/14-chap8'
 import BOOK4OPS15CHAP9 from '@/components/Book4/OPS/15-chap9'
 import BOOK4OPS16CHAP10 from '@/components/Book4/OPS/16-chap10'
 import BOOK4OPS17CHAP11 from '@/components/Book4/OPS/17-chap11'
 import BOOK4OPS18CHAP12 from '@/components/Book4/OPS/18-chap12'
 import BOOK4OPS19PART from '@/components/Book4/OPS/19-part'
 import BOOK4OPS20CHAP13 from '@/components/Book4/OPS/20-chap13'
 import BOOK4OPS21CHAP14 from '@/components/Book4/OPS/21-chap14'
 import BOOK4OPS22CHAP15 from '@/components/Book4/OPS/22-chap15'
 import BOOK4OPS23CHAP16 from '@/components/Book4/OPS/23-chap16'
 import BOOK4OPS24CHAP17 from '@/components/Book4/OPS/24-chap17'
 import LOVE_2 from '@/components/love_2'
 import BOOK4OPS25BIOGRAPHY from '@/components/Book4/OPS/25-biography'
 import BOOK4OPS26BIOGRAPHY from '@/components/Book4/OPS/26-biography'
 import BOOK4OPS27BIOGRAPHY from '@/components/Book4/OPS/27-biography'
 import BOOK4OPS28BIOGRAPHY from '@/components/Book4/OPS/28-biography'
 import BOOK4OPS29BIOGRAPHY from '@/components/Book4/OPS/29-biography'
 import BOOK4OPS30BIOGRAPHY from '@/components/Book4/OPS/30-biography'
 import BOOK4OPS31BIOGRAPHY from '@/components/Book4/OPS/31-biography'
 import COPYRIGHT from '@/components/copyright'
 import BOOK1OPS50AD1 from '@/components/Book1/OPS/50-ad1'
 import BOOK1OPSBACKEDORIMAD_1 from '@/components/Book1/OPS/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/OPS/1-cover",
 			"name" : "Book1/OPS/1-cover",
 			"component" : BOOK1OPS1COVER
 		},
 		{
 			"path" : "/Book1/OPS/3-title_page",
 			"name" : "Book1/OPS/3-title_page",
 			"component" : BOOK1OPS3TITLE_PAGE
 		},
 		{
 			"path" : "/Book1/OPS/4-dedication",
 			"name" : "Book1/OPS/4-dedication",
 			"component" : BOOK1OPS4DEDICATION
 		},
 		{
 			"path" : "/Book1/OPS/5-TOC",
 			"name" : "Book1/OPS/5-TOC",
 			"component" : BOOK1OPS5TOC
 		},
 		{
 			"path" : "/Book1/OPS/6-chap1",
 			"name" : "Book1/OPS/6-chap1",
 			"component" : BOOK1OPS6CHAP1
 		},
 		{
 			"path" : "/Book1/OPS/7-part",
 			"name" : "Book1/OPS/7-part",
 			"component" : BOOK1OPS7PART
 		},
 		{
 			"path" : "/Book1/OPS/8-chap2",
 			"name" : "Book1/OPS/8-chap2",
 			"component" : BOOK1OPS8CHAP2
 		},
 		{
 			"path" : "/Book1/OPS/9-chap3",
 			"name" : "Book1/OPS/9-chap3",
 			"component" : BOOK1OPS9CHAP3
 		},
 		{
 			"path" : "/Book1/OPS/10-chap4",
 			"name" : "Book1/OPS/10-chap4",
 			"component" : BOOK1OPS10CHAP4
 		},
 		{
 			"path" : "/Book1/OPS/11-chap5",
 			"name" : "Book1/OPS/11-chap5",
 			"component" : BOOK1OPS11CHAP5
 		},
 		{
 			"path" : "/Book1/OPS/12-chap6",
 			"name" : "Book1/OPS/12-chap6",
 			"component" : BOOK1OPS12CHAP6
 		},
 		{
 			"path" : "/Book1/OPS/13-chap7",
 			"name" : "Book1/OPS/13-chap7",
 			"component" : BOOK1OPS13CHAP7
 		},
 		{
 			"path" : "/Book1/OPS/14-chap8",
 			"name" : "Book1/OPS/14-chap8",
 			"component" : BOOK1OPS14CHAP8
 		},
 		{
 			"path" : "/Book1/OPS/15-chap9",
 			"name" : "Book1/OPS/15-chap9",
 			"component" : BOOK1OPS15CHAP9
 		},
 		{
 			"path" : "/Book1/OPS/16-chap10",
 			"name" : "Book1/OPS/16-chap10",
 			"component" : BOOK1OPS16CHAP10
 		},
 		{
 			"path" : "/Book1/OPS/17-chap11",
 			"name" : "Book1/OPS/17-chap11",
 			"component" : BOOK1OPS17CHAP11
 		},
 		{
 			"path" : "/Book1/OPS/18-chap12",
 			"name" : "Book1/OPS/18-chap12",
 			"component" : BOOK1OPS18CHAP12
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js